import {
  DocumentRequirement,
  DocumentRequirementsChecklist,
} from '@black-bear-energy/black-bear-energy-common'

export function requirementIsChecklist(
  docRequirement: DocumentRequirementsChecklist | DocumentRequirement
): docRequirement is DocumentRequirementsChecklist {
  return docRequirement.hasOwnProperty('children')
}
